'use strict'

const { coerceImageUrlValue } = require('./image-url')
const { parseDurationInput } = require('./duration-column')

// Rule and filter data types for a column. Signature only answers whether a
// drawing is present. Duration and sequence compare as numbers.

const RULE_DATA_TYPE = {
  text: 'string',
  number: 'number',
  dateTime: 'datetime',
  password: 'string',
  richText: 'string',
  relationship: 'relationship',
  multiselect: 'string',
  address: 'string',
  formula: 'string',
  checkbox: 'checkbox',
  duration: 'number',
  sequence: 'number',
  signature: 'signature'
}

function ruleDataType (type) {

  return RULE_DATA_TYPE[type] || 'string'
}

function formControlForColumn (column) {

  if (!column || !column.type) return null
  if (column.type === 'sequence') return null
  if (column.type === 'relationship') return 'formRelationship'
  if (column.type === 'formula') return 'formInput'
  if (column.type === 'password') return 'formPassword'
  if (column.type === 'richText') return 'formRichText'
  if (column.type === 'multiselect') return 'formMultiSelect'
  if (column.type === 'image' || column.type === 'file') return 'formFile'
  if (column.type === 'signature') return 'formSignature'
  if (column.type === 'duration') return 'formDuration'
  if (column.type === 'dateTime') return 'formDate'
  if (column.type === 'number' || column.type === 'text' || column.type === 'address') return 'formInput'

  return null
}

// A form posts JSON text for a duration or an image address. Turn that text
// into the object the write path already understands. Other strings stay put.
function coerceColumnPayload (column, value) {

  if (!column || typeof value !== 'string') return value

  const text = value.trim()

  if (!text || text[0] !== '{') return value

  if (column.type === 'image') {

    const url = coerceImageUrlValue(text)

    return url || value
  }

  if (column.type === 'duration') {

    const parsed = parseDurationInput(text)

    if (parsed.clear || parsed.invalid) return value
    if (parsed.mode === 'range') return { start: parsed.start, end: parsed.end }
    if (parsed.mode === 'amount') return parsed.amount
  }

  if (column.type === 'signature') {

    try {

      const parsed = JSON.parse(text)

      if (parsed && typeof parsed.data === 'string') return parsed
    } catch (err) {

      return value
    }
  }

  return value
}

function coerceColumnPayloads (columns, values) {

  if (!values || !Array.isArray(columns)) return values

  for (const column of columns) {

    if (!column || !column.uniqueTitle) continue
    if (!Object.prototype.hasOwnProperty.call(values, column.uniqueTitle)) continue

    values[column.uniqueTitle] = coerceColumnPayload(column, values[column.uniqueTitle])
  }

  return values
}

module.exports = {
  RULE_DATA_TYPE,
  ruleDataType,
  formControlForColumn,
  coerceColumnPayload,
  coerceColumnPayloads
}
